import { Mail, MapPin, Phone, Star, Zap } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import QuoteForm from "@/components/QuoteForm";

const GOOGLE_URL = "https://share.google/ne3cGjXAE31IWlowE";

export default function Contact() {
    return (
        <div data-testid="contact-page" className="pt-28 lg:pt-36">
            <section className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
                <Reveal>
                    <p className="font-mono text-xs uppercase tracking-[0.3em] text-gold">Contact &amp; free quote</p>
                    <h1 className="font-display mt-5 max-w-3xl text-4xl font-extrabold tracking-tight sm:text-5xl lg:text-6xl">
                        Tell us about your <span className="text-gold">project.</span>
                    </h1>
                    <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-300">
                        Call, email, or send the form — you'll get a response within 24 hours and a
                        free, written, itemized estimate.
                    </p>
                </Reveal>

                <div className="mt-16 grid gap-14 pb-24 lg:grid-cols-12">
                    <div className="space-y-6 lg:col-span-5">
                        <Reveal>
                            <a href="tel:+16475104012" data-testid="contact-phone-card"
                                className="group flex items-center gap-5 border border-gold/15 bg-ink-3 p-7 transition-colors hover:border-gold/60">
                                <span className="flex h-13 w-13 shrink-0 items-center justify-center border border-gold/40 bg-gold/10 p-4 text-gold">
                                    <Phone size={22} />
                                </span>
                                <span>
                                    <span className="block font-mono text-[11px] uppercase tracking-[0.25em] text-slate-400">Call or text — click to call</span>
                                    <span className="font-display mt-1 block text-2xl font-bold transition-colors group-hover:text-gold">647 510 4012</span>
                                </span>
                            </a>
                        </Reveal>
                        <Reveal delay={0.08}>
                            <a href="mailto:Bnbpaintinginc@gmail.com" data-testid="contact-email-card"
                                className="group flex items-center gap-5 border border-gold/15 bg-ink-3 p-7 transition-colors hover:border-gold/60">
                                <span className="flex h-13 w-13 shrink-0 items-center justify-center border border-gold/40 bg-gold/10 p-4 text-gold">
                                    <Mail size={22} />
                                </span>
                                <span className="min-w-0">
                                    <span className="block font-mono text-[11px] uppercase tracking-[0.25em] text-slate-400">Email — click to send</span>
                                    <span className="mt-1 block break-all text-lg font-semibold transition-colors group-hover:text-gold">Bnbpaintinginc@gmail.com</span>
                                </span>
                            </a>
                        </Reveal>
                        <Reveal delay={0.16}>
                            <div data-testid="contact-area-card" className="flex items-center gap-5 border border-gold/15 bg-ink-3 p-7">
                                <span className="flex h-13 w-13 shrink-0 items-center justify-center border border-gold/40 bg-gold/10 p-4 text-gold">
                                    <MapPin size={22} />
                                </span>
                                <span>
                                    <span className="block font-mono text-[11px] uppercase tracking-[0.25em] text-slate-400">Service area</span>
                                    <span className="mt-1 block text-lg font-semibold">Toronto &amp; the GTA</span>
                                    <span className="mt-2 block text-xs text-slate-400">35 Copeland Cres, Cookstown, ON L0L 1L0</span>
                                    <span className="mt-1 block text-xs text-slate-500">Toronto · Mississauga · Vaughan · Markham · Brampton · Oakville · Burlington · Richmond Hill &amp; more</span>
                                </span>
                            </div>
                        </Reveal>
                        <Reveal delay={0.24}>
                            <a href={GOOGLE_URL} target="_blank" rel="noopener noreferrer" data-testid="contact-google-card"
                                className="group flex items-center gap-5 border border-gold/15 bg-ink-3 p-7 transition-colors hover:border-gold/60">
                                <span className="flex h-13 w-13 shrink-0 items-center justify-center border border-gold/40 bg-gold/10 p-4 text-gold">
                                    <Star size={22} fill="currentColor" strokeWidth={0} />
                                </span>
                                <span>
                                    <span className="block font-mono text-[11px] uppercase tracking-[0.25em] text-slate-400">Google Business</span>
                                    <span className="mt-1 block text-lg font-semibold transition-colors group-hover:text-gold">5.0 rating · 10 reviews</span>
                                    <span className="mt-1 block text-xs text-slate-500">Read reviews and find us on Google</span>
                                </span>
                            </a>
                        </Reveal>
                        <Reveal delay={0.3}>
                            <div data-testid="contact-ai-card" className="border border-gold/25 bg-gold/5 p-7">
                                <p className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.25em] text-gold">
                                    <Zap size={13} /> Automated for builders
                                </p>
                                <p className="mt-3 text-sm leading-relaxed text-slate-300">
                                    Every quote request also triggers our AI assistant: it drafts and
                                    sends professional outreach emails to our general-contractor and
                                    trade partners, plus a weekly lead digest — so the right crews
                                    see your project fast.
                                </p>
                            </div>
                        </Reveal>
                    </div>

                    <Reveal delay={0.1} className="lg:col-span-7">
                        <div className="border border-gold/15 bg-ink-3 p-8 sm:p-10" data-testid="contact-form-card">
                            <h2 className="font-display text-2xl font-bold">Request a free quote</h2>
                            <p className="mt-2 text-sm text-slate-400">Fields marked * are required. Attachments can be emailed after you submit.</p>
                            <div className="mt-8">
                                <QuoteForm source="quote" />
                            </div>
                        </div>
                    </Reveal>
                </div>
            </section>
        </div>
    );
}